import React, { FC } from "react";
import { Alert, CircularProgress, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AlertColor } from "@mui/material/Alert/Alert";

const PhotosProcessingStatusAlert: FC<{
  count: number;
  color?: AlertColor;
}> = ({ count, color = "info" }) => {
  const { t } = useTranslation();

  return (
    <Alert
      severity={color}
      sx={{
        width: "100%",
        ".MuiAlert-message": {
          flex: 1,
          padding: "4px 0",
        },
        ".MuiAlert-ico": {
          alignItems: "center",
        },
      }}
      icon={<CircularProgress color="info" size={20} />}
    >
      <Stack
        flexDirection="row"
        justifyContent="space-between"
        fontSize="14px"
        lineHeight="22px"
        fontWeight="400"
        color="#171A1FFF"
        gap="16px"
      >
        <Typography>{t("photos.processingSnackbar.label")}</Typography>
        <Typography fontWeight="500">
          {t("photos.processingSnackbar.pendingCountLabel", {
            count: count || 1,
          })}
        </Typography>
      </Stack>
    </Alert>
  );
};

export default PhotosProcessingStatusAlert;
